import { registerFormInputComponent } from '@vendure/admin-ui/core';
import { ProductVariantFlexibleQuantityFormInput } from './input-form.component';

export default [
    registerFormInputComponent(
        'product-variant-flexible-quantity-form-input',
        ProductVariantFlexibleQuantityFormInput
    ),
];
